import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";


export class Countup {
  // countupTime in mileseconds
  private countupTime: number = 2000;
  private countupInterval: number = 10;

  constructor(private $log: Logger, private $utils: Utils) {
    const countups: NodeListOf<HTMLElement> = document.querySelectorAll('.js-countup');

    countups?.forEach(countup => {
      this.initCountup(countup);
    });
  }

  private initCountup(countup: HTMLElement) {
    const startValue: string = countup.innerHTML;
    const startNumber = Number.parseInt(startValue.replace(/[^\d]/g, ''));
    const extractedNumbers = this.extractFormat(startValue);
    const countupSteps = startNumber / (this.countupTime / this.countupInterval);

    let value: number = 0;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const interval = setInterval(() => {
            value += countupSteps;

            if (value >= startNumber) {
              value = startNumber;
              clearInterval(interval);
            }

            countup.innerHTML = this.applyOriginalFormat(value, extractedNumbers);

          }, this.countupInterval);

          observer.disconnect();
        }
      });
    },{
      root: null,
      threshold: 0.5
    });

    observer.observe(countup);
  }

  private extractFormat(input: string) {
    const result = input.match(/\d+|[^\d]/g);
    return result;
  }

  private applyOriginalFormat(value: number, extractedNumbers: Array<string>): string {
    value = Math.round(value);
    // Get all digit-only parts
    const digitParts = extractedNumbers.filter(part => /^\d+$/.test(part));

    // Count total digits in template
    const totalDigits = digitParts.reduce((sum, part) => sum + part.length, 0);

    // Pad the new value to match total digits
    const newValueStr = value.toString().padStart(totalDigits, '0');

    // Build formatted output
    let result = '';
    let digitIndex = 0;

    for (let part of extractedNumbers) {
      if (/^\d+$/.test(part)) {
        const len = part.length;
        result += newValueStr.slice(digitIndex, digitIndex + len);
        digitIndex += len;
      } else {
        result += part;
      }
    }

    return result;
  }
}
